import Spinner from "components/Loader/Spinner";
import React, { memo, useState, useEffect } from "react";
// import Carousal from "components/Dashboard/Carousal.jsx";
import { Modal } from "react-bootstrap";
import YoutubeVideoPlayer from "./YoutubeVideoPlayer";
import { isWhiteLabel } from "utils/whiteLabel";

const TuteVideos = memo(function TuteVideos({ videos }) {
  const isWL = isWhiteLabel();
  
  return (
    <div className="row m-0">
      <div className="dashboard-videos-section">
        <div className="dashboard-videos-header">
          <h2 className="title">PTE Tutorial Videos</h2>
          {!isWL && <Tabs />}
        </div>
        <div className="tab-content" id="myTabContent">
          <Videos videos={videos} isWhiteLabel={isWL} />
        </div>
      </div>
    </div>
  );
});
export default TuteVideos;

const Videos = ({ videos, isWhiteLabel }) => {
  const [videoModal, setVideoModal] = useState(false);
  const [videoYTModal, setYTVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const openModal = (video_url) => {
    setVideoUrl(video_url);
    setVideoModal(true);
  };

  const toggle = () => {
    setVideoModal(false);
    setVideoUrl("");
  };

  const openYTModal = (video_url) => {
    setVideoUrl(video_url);
    setYTVideoModal(true);
  };

  const toggleYT = () => {
    setYTVideoModal(false);
    setVideoUrl("");
  };

  if (isWhiteLabel) {
    // White-label: Vimeo videos in simple array format, no tabs
    return (
      <>
        <WhiteLabelVideoArea videos={videos} openModal={openModal} openYTModal={openYTModal} setVideoModal={setVideoModal} />
        {videoModal && <PlayVideoModal isOpen={videoModal} toggle={toggle} videoUrl={videoUrl} />}
        {videoYTModal && <YoutubeVideoPlayer isOpen={videoYTModal} toggle={toggleYT} videoUrl={videoUrl} />}
      </>
    );
  }

  // Regular site: object with tab keys
  return (
    <>
      <TabArea active="active" tab="speaking" videos={videos} openModal={openYTModal} setVideoModal={setYTVideoModal} />
      <TabArea active="" tab="writing"   videos={videos} openModal={openYTModal} setVideoModal={setYTVideoModal} />
      <TabArea active="" tab="reading"   videos={videos} openModal={openYTModal} setVideoModal={setYTVideoModal} />
      <TabArea active="" tab="listening" videos={videos} openModal={openYTModal} setVideoModal={setYTVideoModal} />
      <TabArea active="" tab="others"    videos={videos} openModal={openYTModal}   setVideoModal={setYTVideoModal} />

      {videoYTModal && <YoutubeVideoPlayer isOpen={videoYTModal} toggle={toggleYT} videoUrl={videoUrl} />}
      {videoModal   && <PlayVideoModal   isOpen={videoModal}   toggle={toggle}   videoUrl={videoUrl} />}
    </>
  );
};
// const PlayYTVideoModal = ({ isOpen, toggle, videoUrl }) => {
//   const [loaded, setLoaded] = useState(false);

//   const frameLoad = () => {
//     setLoaded((prevState) => !prevState);
//   };
//   return (
//     <Modal
//       show={isOpen}
//       size="md"
//       modalClassName="dashboard-video-popup"
//       className="modal-dialog-centered"
//     >
//       <div className="modal-header d-flex align-items-center justify-content-between p-3">
//         <h5 className="modal-title FS16FW500">PTE Tutorial Videos</h5>
//         <button
//           type="button"
//           className="btn-close"
//           aria-label="Close"
//           onClick={toggle}
//         ></button>
//       </div>
//       <Modal.Body className="d-flex align-items-center justify-content-center flex-column">
        
//         <iframe
//           className="dashboard-popup-video"
//           src={videoUrl}
//           title="YouTube Live video player"
//           frameBorder="0"
//           onLoad={frameLoad}
//           style={{   
//            width: "clamp(258px, 50vw, 444px)",  
//            height: "clamp(120px, 30vw, 250px)",
//         }}
//         ></iframe>
//         {!loaded && <div className="text-center">
//           {/* <Spinner/> */}
//            <p className="FS14FW600">Loading...</p>
//            </div>}
//       </Modal.Body>
//     </Modal>
//   );
// };


const PlayVideoModal = ({ isOpen, toggle, videoUrl }) => {
  const [loaded, setLoaded] = useState(false);

  const frameLoad = () => {
    setLoaded((prevState) => !prevState);
  };
  return (
    <Modal
      show={isOpen}
      size="xl"
      className="modal-dialog-centered dashboard-video-popup"
    >
      <div className="modal-header d-flex justify-content-between">
        <h5 className="modal-title FS16FW500">New tips and strategies</h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        ></button>
      </div>
      <Modal.Body className="d-flex align-items-center justify-content-center flex-column">
        <iframe
          className="dashboard-popup-video"
          src={videoUrl}
          title="YouTube Live video player"
          frameBorder="0"
          onLoad={frameLoad}
        //    style={{   
        //    width: "clamp(258px, 70vw, 444px)",  
        //    height: "clamp(120px, 30vw, 500px)",
        // }}
        ></iframe>
        {!loaded && <div className="text-center">Loading...</div>}
      </Modal.Body>
    </Modal>
  );
};

const VideoThumbnail = ({ videoUrl, onClick }) => {
  const [thumbnail, setThumbnail] = useState(null);
  const [loading, setLoading] = useState(true);
  const isYoutube = videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be') || videoUrl.includes('/embed/');

  useEffect(() => {
    if (isYoutube) {
      const videoId = videoUrl.split('/embed/')[1]?.split('?')[0]
        || videoUrl.split('v=')[1]?.split('&')[0]
        || videoUrl.split('youtu.be/')[1]?.split('?')[0];
      if (videoId) setThumbnail(`https://img.youtube.com/vi/${videoId}/mqdefault.jpg`);
      setLoading(false);
      return;
    }

    const videoId = videoUrl.split('/video/')[1]?.split('?')[0];
    if (!videoId) { setLoading(false); return; }

    fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
      .then((res) => res.json())
      .then((data) => { if (data?.[0]?.thumbnail_medium) setThumbnail(data[0].thumbnail_medium); })
      .catch(() => setThumbnail(null))
      .finally(() => setLoading(false));
  }, [videoUrl]);

  return (
    <div className="video-thumbnail-wrapper" style={{ position: 'relative', cursor: 'pointer' }} onClick={onClick}>
      {loading ? (
        <div
          className="dashboard-video"
          style={{
            width: '190px',
            height: '110px',
            backgroundColor: '#1a1a2e',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            borderRadius: '8px',
          }}
        >
          <Spinner />
        </div>
      ) : thumbnail ? (
        <img
          src={thumbnail}
          alt="Video thumbnail"
          className="dashboard-video"
          style={{
            width: '190px',
            height: '110px',
            objectFit: 'cover',
            maxWidth: "fit-content",
            borderRadius: '8px',
          }}
        />
      ) : (
        <div
          className="dashboard-video"
          style={{
            width: '190px',
            height: '110px',
            backgroundColor: '#1a1a2e',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            borderRadius: '8px',
          }}
        >
          <span style={{ fontSize: '32px' }}>&#9654;</span>
        </div>
      )}
      {/* Play button overlay */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50px',
        height: '50px',
        background: 'rgba(255,0,0,0.85)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}>
        <span style={{ color: 'white', fontSize: '20px', marginLeft: '4px' }}>&#9654;</span>
      </div>
    </div>
  );
};

const WhiteLabelVideoArea = ({ videos, openModal,openYTModal, setVideoModal }) => {

  const hasVideos = videos && Array.isArray(videos) && videos.length > 0;
  const isYoutube = (url) => url.includes('youtube.com') || url.includes('youtu.be') || url.includes('/embed/');

  return (
    <div className="tab-pane fade show active" role="tabpanel">
      <div className="dashboard-videos-row">
        {hasVideos ? (
          videos.map((video, i) => {
            return (
              <div
                className="video-card"
                key={video.id || i}
              >
                <VideoThumbnail
                videoUrl={video.video}
                onClick={() => isYoutube(video.video) ? openYTModal(video.video) : openModal(video.video)}
              />
                <div className="dashboard-video-content">
                  <p className="video-sub-title">&nbsp;</p>
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-videos-state" style={{ 
            textAlign: 'center', 
            padding: '40px 20px',
            color: '#666',
            width: '100%'
          }}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px', color: '#333' }}>
              No Videos Available
            </h3>
            <p style={{ fontSize: '14px', margin: '0', opacity: 0.7 }}>
              There are currently no tutorial videos available.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const TabArea = ({ active, tab, videos, openModal,setVideoModal }) => {
  
  function getYouTubeThumbnail(embedUrl, quality = 'mqdefault') {
    const videoId = embedUrl.split('/embed/')[1]?.split('?')[0];
    if (!videoId) return null;
    return `https://img.youtube.com/vi/${videoId}/${quality}.jpg`;
  }

  // Check if videos exist and if the current tab has videos
  const hasVideos = videos && videos[tab] && videos[tab].length > 0;

  return (
    <div
      className={`tab-pane fade show ${active}`}
      id={tab}
      role="tabpanel"
      aria-labelledby={`${tab}-tab`}
    >
      <div className="dashboard-videos-row">
        {hasVideos ? (
          videos[tab].map((video, i) => {
            const thumbnail = getYouTubeThumbnail(video.video);
            return (
              <div
                className="video-card"
                onClick={() =>{ openModal(video.video); setVideoModal(true); }}
                key={i}
              >
                <div className="video-thumbnail-wrapper" style={{ position: 'relative', cursor: 'pointer' }}>
                  <img
                    src={thumbnail}
                    alt="Video thumbnail"
                    className="dashboard-video"
                    style={{
                      width: '190px',
                      height: '110px',
                      objectFit: 'cover',
                      maxWidth:"fit-content"
                      }}
                  />
                  {/* Play button overlay */}
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '50px',
                    height: '50px',
                    background: 'rgba(255,0,0,0.85)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none',
                  }}>
                    <span style={{ color: 'white', fontSize: '20px', marginLeft: '4px' }}>▶</span>
                  </div>
                </div>
                <div className="dashboard-video-content">
                  <p className="video-sub-title">&nbsp;</p>
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-videos-state" style={{ 
            textAlign: 'center', 
            padding: '40px 20px',
            color: '#666',
            width: '100%'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }}>🎥</div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px', color: '#333' }}>
              No Videos Available
            </h3>
            <p style={{ fontSize: '14px', margin: '0', opacity: 0.7 }}>
              There are currently no tutorial videos available for {tab.charAt(0).toUpperCase() + tab.slice(1)}.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const Tabs = () => {
  const tabs = [
    {
      label: "Speaking",
      active: "active",
      tab: "speaking",
      ariaSelected: "true",
    },
    {
      label: "Writing",
      active: "",
      tab: "writing",
      ariaSelected: "false",
    },
    {
      label: "Reading",
      active: "",
      tab: "reading",
      ariaSelected: "false",
    },
    {
      label: "Listening",
      active: "",
      tab: "listening",
      ariaSelected: "false",
    },
    {
      label: "Others",
      active: "",
      tab: "others",
      ariaSelected: "false",
    },
  ];

  return (
    <ul className="nav nav-tabs" id="myTab" role="tablist">
      {tabs.map((tab, i) => {
        return (
          <TabItem
            label={tab.label}
            active={tab.active}
            tab={tab.tab}
            ariaSelected={tab.ariaSelected}
            key={i}
          />
        );
      })}
    </ul>
  );
};

const TabItem = ({ active, tab, ariaSelected, label }) => {
  return (
    <li className="nav-item" role="presentation">
      <button
        className={`nav-link ${active}`}
        id={`${tab}-tab`}
        data-bs-toggle="tab"
        data-bs-target={`#${tab}`}
        type="button"
        role="tab"
        aria-controls={tab}
        aria-selected={ariaSelected}
      >
        {label}
      </button>
    </li>
  );
};
